var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0h32a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M30.865 13.835l-5.698-5.698a1.982 1.982 0 0 0-1.397-.578H11.857a2.799 2.799 0 0 0-2.798 2.8v19.813a2.797 2.797 0 0 0 2.798 2.798h16.99c1.548 0 2.8-1.252 2.8-2.798V15.724c0-.709-.282-1.388-.782-1.889"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#495057",
    fillRule: "nonzero",
    d: "M31.395 13.305a3.427 3.427 0 0 1 1.002 2.42v14.447a3.548 3.548 0 0 1-3.55 3.548h-16.99a3.547 3.547 0 0 1-3.548-3.548V10.358c0-1.96 1.588-3.55 3.548-3.55H23.77c.721 0 1.414.288 1.928.799l5.697 5.698zm-6.757-4.636a1.232 1.232 0 0 0-.868-.36H11.857a2.049 2.049 0 0 0-2.048 2.05v19.813c0 1.132.916 2.048 2.048 2.048h16.99c1.134 0 2.05-.916 2.05-2.048V15.724c0-.508-.202-.997-.563-1.359L24.638 8.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#495057",
    fillRule: "nonzero",
    d: "M31.647 14.847a.75.75 0 0 1 0 1.5h-6.468a2.16 2.16 0 0 1-2.16-2.16V7.559a.75.75 0 1 1 1.5 0v6.628c0 .364.296.66.66.66h6.468z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.3b4528b59394f096246e6944715a2141.svg";
export { ForwardRef as ReactComponent };